export const MenuInitialData = {
  payload: {
    name: "",
    redirect_type: "url",
    files: {},
  },
};
